module.exports = __webpack_public_path__ + "media/images/img_class01-b510ee6b5cfc303b5cf56dd9907b7174.jpg";